import React from "react";
import { sustainability as S } from "../mock";
import { Shirt, Layers, Armchair, Leaf, Scissors, Settings } from "lucide-react";
import useReveal from "../hooks/useReveal";

const ICONS = { Shirt, Layers, Armchair, Leaf, Scissors };

export default function Capabilities() {
  const [ref, inView] = useReveal();

  return (
    <section id="capabilities" className="kse-section kse-section--dark bg-[#1a2a6b] relative overflow-hidden">
      {/* subtle decorative */}
      <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-white/5" />
      <div className="absolute -left-24 bottom-0 w-80 h-80 rounded-full bg-white/5" />

      <div className="kse-container relative z-10">
        <div ref={ref} className="grid lg:grid-cols-2 gap-14 items-center">
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <span className="kse-eyebrow kse-eyebrow--light">
              {S.eyebrow}
            </span>
            <h2 className="kse-h2 kse-h2--light mb-6 whitespace-pre-line">
              {S.title}
            </h2>
            <p className="text-blue-100/80 leading-relaxed mb-8 text-[15px] sm:text-base">
              {S.desc}
            </p>
            <div className="flex flex-wrap gap-3">
              {S.subMetrics.map((m) => {
                const Icon = ICONS[m.icon] || Settings;
                return (
                  <div key={m.value} className="flex items-center gap-3 bg-white/10 rounded-2xl px-4 py-3 backdrop-blur-sm">
                    <Icon className="text-blue-200" size={22} />
                    <div>
                      <div className="text-white font-bold text-sm">{m.value}</div>
                      <div className="text-blue-100/70 text-xs">{m.label}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className={`reveal ${inView ? "in-view" : ""}`} style={{ animationDelay: "0.15s" }}>
            <img src={S.image} alt="Fabric and textiles" className="rounded-3xl shadow-2xl w-full h-[360px] object-cover" />
          </div>
        </div>

        {/* Capacity metrics */}
        <div className="grid sm:grid-cols-3 gap-6 mt-16">
          {S.metrics.map((m, i) => {
            const Icon = ICONS[m.icon] || Settings;
            return (
              <div key={m.label} className={`text-center border border-white/15 rounded-2xl py-8 px-4 hover:bg-white/5 transition-colors reveal ${inView ? "in-view" : ""}`} style={{ animationDelay: `${0.2 + i * 0.1}s` }}>
                <Icon className="text-blue-200 mx-auto mb-4" size={30} strokeWidth={1.6} />
                <div className="text-3xl font-extrabold text-white">{m.value}</div>
                <div className="text-blue-200 text-sm font-medium">{m.unit}</div>
                <div className="text-blue-100/70 text-sm mt-2">{m.label}</div>
              </div>
            );
          })}
        </div>

        {/* Machinery detail moved to dedicated Machinery section */}
      </div>
    </section>
  );
}
